import { AppComponent } from 'src/app/app.component';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ElementRef } from '@angular/core';
import { BallotsService } from 'src/app/services/ballots.service';
import { ToastService } from 'src/app/services/toast.service';
import { parseISO } from 'date-fns';
import { AlertController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-my-ballots',
  templateUrl: './my-ballots.page.html',
  styleUrls: ['./my-ballots.page.scss'],
})
export class MyBallotsPage implements OnInit {

  ballots: any[]                                          // ballottaggi
  ballotsPair: any[]                                      // coppie di ballottaggi
  ballot: any                                             // ballottaggio corrente

  hidden = false;                                         // finalizzati all'animazione per la cancellazione
  animateBeforeDelete = false;
  animateBeforeDeleteBallotId = null;                     // l'id del ballottaggio che si sta eliminando, reimpostare a null a eliminazione avvenuta

  // PARAMETRI PER MyBallotComponent -------------------------------------------------------------------------
  showBallotsPair = true;               // PAGINA/coppie per selezione ballottaggi,  in questa pagina (MyBallotsPage)
  showVotesOf: number = null;           // COMPONENT/singolo ballottaggio: true=mostra scheda SENZA le percentuali
  // ballot.id=mostra scheda CON le percentuali
  showVotesBeforeBallot: boolean = true //  true: mostra i punteggi senza passare per la votazione
  // false: propone la votazione, poi mostra i punteggi
  pageTitle: string // ="Controlla l'andamento dei tuoi ballottaggi"
  countdown: string= "" // countdown al prossimo end-date
  loggedUser: any;

  constructor(
    private ballotsService: BallotsService,
    private toastService: ToastService,
    private alertController: AlertController,
    private userService: UserService,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private appcomponent: AppComponent,
  ) {

   }

  ngOnInit() { // carica ballots, crea ballotsPair
    this.route.params.subscribe(params => console.log(params));
    this.initialize();
  }

  timerEndDate() {
    console.log('verifico enddate')
    let tmp_countdown='';
    const enddate = this.appcomponent.expiration_date_ballot;
    let now = new Date().getTime();
    let dt_end: any = this.appcomponent.isPlatformIos ? new Date(parseISO(enddate).getTime()) : Date.parse(enddate);
    let distance=dt_end-now;
    console.log(distance, dt_end, now, enddate, this.appcomponent.isPlatformIos )
    if (distance>0) {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24)); // trasformazione in DD, HH, MM
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);  // secondi: solo per i test

      if (days >=1){
        tmp_countdown = days.toString()+'g'
        if (hours != 0) tmp_countdown=tmp_countdown+ ' ' + hours.toString()+'h'
        return tmp_countdown;
      }
      // distanza: meno di un giorno
      if (hours <=23){
        tmp_countdown = hours.toString()+'h'
        //tmp_countdown = hours.toString()+'h ' + minutes.toString()+'m'
      }
      if (hours ==0){
        tmp_countdown = tmp_countdown + ' ' + minutes.toString()+'m'
        //tmp_countdown = this.minutes.toString()+'m'
      }
      return tmp_countdown;
    }
    return tmp_countdown;
  }

  ngOnChanges() {
    this.initialize();
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.countdown=this.timerEndDate();
  }

  async initialize() {
    this.showBallotsPair = true;
    this.showVotesOf = null;
    this.loggedUser = await this.userService.getLoggedUser();
    console.log("USER ->",this.loggedUser);

    // if (!!this.ballots && this.ballots.length > 0) {
    //   return;
    // }

    await this.ballotsService.refreshMyBallots(true);

    this.ballotsService.myBallotsObservable.subscribe((ballots) => {
      this.ballotsPair = [];
      if (!!ballots) {
        this.ballots = this.ballotsService.improveBallotsList(ballots);

        this.ballotsPair = this.computeBallotsPair(this.ballots);

        if (this.ballots.length > 0) {
          this.pageTitle = "Controlla l'andamento dei tuoi ballottaggi";
        } else {
          this.pageTitle = "Crea dei ballottaggi, e controlla l'andamento";
        }
      }
    });
  }

  returnedFromBallotComponent($event: any) {
    this.initialize();
  }

  showSingleBallotWithVotation(ballot_id: number) {
    //alert("MyBallotsPage/showSingleBallotWithVotation - id : " + ballot_id.toString())
    let appo = this.ballots.filter(item => { return item.id == ballot_id });
    this.ballot = appo[0];
    //this.showVotesOf = this.ballot.id   // forza la presentazione delle percentuali in MyBallotComponent
    this.showVotesOf = null;               // NON MOSTRA LE PERCENTUALI in MyBallor Component (18/6/2021)
    this.showBallotsPair = false;          // mostra il ballottaggio in MyBallotComponent
    this.showVotesBeforeBallot = true;
  }



  showSingleBallotWithoutVotation(ballot_id: number) {
    // alert("MyBallotsPage/showSingleBallotWithoutVotation - id : " + ballot_id.toString())
    let appo = this.ballots.filter(item => { return item.id == ballot_id });
    this.ballot = appo[0];
    console.log("BALLOTT ",this.ballot)
    //this.showVotesOf = this.ballot.id   // MOSTRA LE PERCENTUALI in MyBallot
    this.showVotesOf = null;               // NON MOSTRA LE PERCENTUALI in MyBallot Component (modifica 18/6/2021)
    this.showBallotsPair = false;
    this.showVotesBeforeBallot = false;
  }

  async delete(ballot_id: number) {
    this.animateBeforeDeleteBallotId = ballot_id;

    // disabilita la scheda/ballottaggio da cancellare e i suoi pulsanti
    let elementIdSelectCard = "#ballot-" + ballot_id.toString();
    let deletedCard: HTMLElement = this.elRef.nativeElement.querySelector(elementIdSelectCard);
    deletedCard.setAttribute("disabled", "true");
    //deletedCard.classList.add("class-when-deleted") eventuale per animazioni individuali

    let elementIdSelectDelete = "#delete-" + ballot_id.toString();
    let deletedButton: HTMLElement = this.elRef.nativeElement.querySelector(elementIdSelectDelete);
    deletedButton.setAttribute("disabled", "true");

    let elementIdSelectAggiorna = "#aggiorna-" + ballot_id.toString();
    let aggiornadButton: HTMLElement = this.elRef.nativeElement.querySelector(elementIdSelectAggiorna);
    aggiornadButton.setAttribute("disabled", "true");

    let elementIdSelectResize = "#resize-" + ballot_id.toString();
    let resizeButton: HTMLElement = this.elRef.nativeElement.querySelector(elementIdSelectResize);
    resizeButton.setAttribute("disabled", "true");

    // Trigger animation
    this.toastService.presentMediumToast("cancellazione del ballottaggio");
    this.animateBeforeDelete = true;
    this.hidden = false;
    const t = setTimeout(() => {
      this.animateBeforeDelete = false;
      this.animateBeforeDeleteBallotId = null;
      this.hidden = false;
    }, 3000);
    // this.initialize() : OMESSO PER LA CANCELLAZIONE DEL BALLOTTAGGIO
    //    _refreshMyBallots = false: introdotto il 4/7/2021, evita il refresh dopo la cancellazione sul data base
    let _refreshMyBallots: boolean;
    if (this.ballots.length > 1) { _refreshMyBallots = false; }     // la griglia rimane, evidenziando le cancellazioni
    else { _refreshMyBallots = true; }                           // l'ultimo ballottaggio cancella la griglia
    const response = await this.ballotsService.deleteBallot(ballot_id, _refreshMyBallots);
    if (response.status === 'ok') {
      //console.log(`Ballot ${this.ballot.id} Was deleted`);
    } else {
      this.toastService.presentErrToast("MyBallotsPage/delete() - ERRORE DI SISTEMA [" + response.status + "] nella cancellazione del ballottaggio");
    }
  }

  // --------------------------------------------------------------------
  //  splitta i ballottaggi nelle componenti left e rigth
  // --------------------------------------------------------------------
  computeBallotsPair(myBallots) {
    let myBallotsPair = [];
    let appo0 = null;
    let appo1 = null;
    for (let i = 0; i < myBallots.length; i++) {
      let pair = i % 2  // resto della divisione per 2 : se 1 => coppia risolta
      if (pair == 0) {
        appo0 = this.computeBallotsPair_obj(this.ballots[i]);
        try {
          appo1 = this.computeBallotsPair_obj(this.ballots[i + 1]);
        }
        catch {
          appo1 = {
            id: 0,
            type: "...",
            dstype: "...",
            dsmatrix: "...",
            surnames: []
          };
        }
        let obj = { left: appo0, rigth: appo1 }
        myBallotsPair.push(obj);

      }
    }
    return myBallotsPair;
  }

  computeBallotsPair_obj(myBallot) {
    let dstype = "";
    let dsmatrix = "";
    let surnames = [];
    switch (myBallot.type) {
      case "exchange":
        dstype = "SCAMBIO";
        dsmatrix = myBallot.matrixArray[0] + " X " + myBallot.matrixArray[0];
        let surnamesLeft = myBallot.left_players.map(item => { return item.surname });
        let surnamesRigth = myBallot.right_players.map(item => { return item.surname });
        surnames = surnamesLeft.concat(surnamesRigth);
        //surnames = ["pippo", "pluto", "topolino", "paperino-overflow", "minni"];
        break;
      case "formation":
        dstype = "FORMAZIONE";
        dsmatrix = myBallot.matrixArray[0] + " SU " + myBallot.matrixArray[1];
        surnames = myBallot.players.map(item => item.surname);
        break;
      case "purchase":
        dstype = "ACQUISTO";
        dsmatrix = myBallot.matrixArray[0] + " SU " + myBallot.matrixArray[1];
        surnames = myBallot.players.map(item => item.surname);
        break;
      default:
        dstype = "tipo non previsto : " + myBallot.type;
        dsmatrix = "";
        surnames = [];
    }
    let obj = {
      id: myBallot.id,
      type: myBallot.type,
      dstype: dstype,
      dsmatrix: dsmatrix,
      surnames: surnames,
      boosted: myBallot.boosted
    };
    return obj;
  }

}
